import React from "react";

const TestimonialModal = ({ testimonial, onClose }) => {
  if (!testimonial) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 100
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff",
          padding: "24px",
          borderRadius: "16px",
          maxWidth: "600px",
          width: "90%"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <p className="text-base mb-lg" style={{ fontStyle: "italic" }}>
          “{testimonial.review}”
        </p>

        <strong>{testimonial.name}</strong>
        <div className="text-sm" style={{ color: "var(--text-secondary)" }}>
          {testimonial.college}
        </div>
      </div>
    </div>
  );
};

export default TestimonialModal;
